class OfficeId {
  constructor(private _value: number = Number.NaN) {

  }

  get value() {
    return this._value;
  }
}

export default OfficeId;